export const INDICATION_SET = 'INDICATION_SET';
export const INDICATION_DELETE = 'INDICATION_DELETE';

export function extractPayloadMessages(indicationID, payload) {
  const messagesClasses = {
    message: 'success',
    error: 'danger',
    info: 'info',
    warning: 'warning'
  };
  const messagesTypes = ['message', 'error', 'info', 'warning'];
  let messages = [];

  messagesTypes.forEach(messageType => {
    if (Array.isArray(payload[messageType])) {
      messages = messages.concat(
        payload[messageType].map((message, index) => ({
          id: `${indicationID}-${index}`,
          text: message,
          type: messagesClasses[messageType],
          blocking: false
        }))
      );
    }
  });
  return messages;
}

function indicationSetAction(indicationID, messages) {
  return {
    type: INDICATION_SET,
    payload: {
      [indicationID]: messages
    }
  };
}

export function indicationDelete(indicationID) {
  return {
    type: INDICATION_DELETE,
    payload: indicationID
  };
}

export function getIndicationID(action = {}) {
  const { payload } = action;
  return action.type + (payload && payload.id ? `_${payload.id}` : '');
}

export function getLoadingMessage(indicationID) {
  return [
    {
      id: indicationID,
      text: 'Loading...',
      type: 'info',
      blocking: true,
      async: true
    }
  ];
}

export function indicationSet(indicationID, messages) {
  return dispatch => {
    if (messages.length > 0) {
      dispatch(indicationSetAction(indicationID, messages));
    } else {
      dispatch(indicationDelete(indicationID));
    }
  };
}
